import React from 'react';
import Styled from 'styled';

import defaultStyles from './outside-link.scss';

export interface Props {
    link: string | undefined | null;
    styles: typeof defaultStyles;
}

class OutsideLink extends React.PureComponent<Props> {
    render() {
        const { link, styles } = this.props;

        if (link == null) {
            return null;
        }

        const displayedLink = link.replace(/^https?:\/\//, '');
        return (
            <a
                key={link}
                href={`${link.includes('@') ? 'mailto:' : link.match(/^https?:\/\//) ? '' : 'http://'}${link}`}
                target='_blank'
                rel='noopener'
                className={styles.link}
            >
                {displayedLink}
            </a>
        );
    }
}

export default Styled(defaultStyles)(OutsideLink);
